module.exports = __webpack_public_path__ + "static/media/One.f8089732.PNG";